import environment from 'constants/environments';
import { AxiosRequestConfig } from 'axios';
import axios from 'utils/FakeService/axios-setting';
import commonService from 'utils/commonService';

/**
 * @description axios get http-request
 * @param url api URL
 * @param params api params
 */
const get = async (url: string, config?: AxiosRequestConfig) => {
  return axios.get(url, config)
    .then(async (response) => {
      return commonService.isHttpRespSuccess(response) ? response.data : null;
    })
    .catch((error) => {
      return handleError(url, error);
    });
};

/**
 * @description axios post http-request
 * @param url api URL
 * @param params api params
 */
const post = async (url: string, data?: any, config?: AxiosRequestConfig) => {
  return axios.post(url, data, config)
    .then(async (response) => {
      return commonService.isHttpRespSuccess(response) ? response.data : null;
    })
    .catch((error) => {
      return handleError(url, error);
    });
};

/**
 * @description Handle request error
 * @param url api URL
 * @param error request error
 */
const handleError = (url: string, error: any) => {
  // (源碼掃描) 修正 System Information Leak 問題，僅 SIT/UAT 環境顯示錯誤訊息
  if (environment.debug) {
    // (源碼掃描) 此處先註解，若 SIT/UAT 環境需要偵錯再自行開啟
    // const { response } = error;
    // console.log(`%c API發生例外錯誤 ${((response && response.status) ? `status code [${response.status}]` : '')}`, 'color: #BB2E29; font-size: 14px; font-weight: bold;');
  }
  return Promise.reject(error);
};

export default {
  post,
  get
};
